import { render, staticRenderFns } from "./SensorDisplay.vue?vue&type=template&id=400ab55e&scoped=true&"
import script from "./SensorDisplay.vue?vue&type=script&lang=js&"
export * from "./SensorDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400ab55e",
  null
  
)

export default component.exports